"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransactionError = exports.ProductViewError = exports.ProductClickError = void 0;
/**
 * <h4>Tracking errors</h4>
 *
 * @packageDocumentation
 */
var ProductClickError_1 = require("./ProductClickError");
Object.defineProperty(exports, "ProductClickError", { enumerable: true, get: function () { return ProductClickError_1.ProductClickError; } });
var ProductViewError_1 = require("./ProductViewError");
Object.defineProperty(exports, "ProductViewError", { enumerable: true, get: function () { return ProductViewError_1.ProductViewError; } });
var TransactionError_1 = require("./TransactionError");
Object.defineProperty(exports, "TransactionError", { enumerable: true, get: function () { return TransactionError_1.TransactionError; } });
//# sourceMappingURL=index.js.map